var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_13281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_9156_13281)"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1653 13.167V19.1673H11.1659C10.9007 19.1673 10.6464 19.062 10.4589 18.8744C10.2714 18.6869 10.166 18.4325 10.166 18.1673V13.167H16.1653Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1657 13.167V18.1673C20.1657 18.4325 20.0603 18.6869 19.8728 18.8744C19.6853 19.062 19.431 19.1673 19.1658 19.1673H17.166V13.167H20.1657Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1649 10.167V12.1672H10.166V10.167C10.166 9.90182 10.2714 9.64745 10.4589 9.4599C10.6464 9.27235 10.9007 9.16699 11.1659 9.16699H19.165C19.4302 9.16699 19.6845 9.27235 19.872 9.4599C20.0596 9.64745 20.1649 9.90182 20.1649 10.167Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6V12H12V6Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6V12H12V6Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9156_13281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9156_13281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6V12H12V6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9156_13281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12C10.6568 12 12 10.6568 12 9C12 7.34315 10.6568 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6568 7.34315 12 9 12Z",
    fill: "url(#paint1_linear_9156_13281)"
  }))))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C8.20888 5 7.43552 5.2346 6.77772 5.67412C6.11992 6.11365 5.60723 6.73836 5.30448 7.46927C5.00173 8.20017 4.92252 9.00444 5.07686 9.78036C5.2312 10.5563 5.61217 11.269 6.17157 11.8284C6.73098 12.3878 7.44372 12.7688 8.21964 12.9231C8.99556 13.0775 9.79983 12.9983 10.5307 12.6955C11.2616 12.3928 11.8864 11.8801 12.3259 11.2223C12.7654 10.5645 13 9.79112 13 9C13 7.93913 12.5786 6.92172 11.8284 6.17157C11.0783 5.42143 10.0609 5 9 5ZM10.9815 9.26461C10.9726 9.32495 10.9421 9.38001 10.8958 9.4196C10.8494 9.4592 10.7902 9.48066 10.7292 9.48H7.27077C7.20959 9.48267 7.1497 9.46186 7.10337 9.42182C7.05704 9.38177 7.02776 9.32554 7.02154 9.26461C7.00615 9.07621 7.00615 8.88686 7.02154 8.69846C7.03039 8.63866 7.06041 8.58401 7.10616 8.54448C7.1519 8.50495 7.21031 8.48316 7.27077 8.48308H10.7292C10.7902 8.48242 10.8494 8.50388 10.8958 8.54347C10.9421 8.58307 10.9726 8.63813 10.9815 8.69846C10.9969 8.88686 10.9969 9.07621 10.9815 9.26461Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9156_13281",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9156_13281",
    x1: 9,
    y1: 6,
    x2: 9,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_13281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9156_13281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDashboard);
export default __webpack_public_path__ + "static/media/delete-dashboard.fe10341e68ac624d95f62a5ce04b1009.svg";
export { ForwardRef as ReactComponent };